import pro1 from "../assets/Ezra Android.jpg";
import pro2 from "../assets/KB Outfit.png";
import pro3 from "../assets/Ella Tech.png";

const MobileData = [
  {
    imgsrc: pro1,
    title: "EZRA Seminary Mobile App",
    text: "E-learning application developed using React Native CLI.",
    android: "https://play.google.com/store/apps/details?id=com.ezraapp&hl=en",
    iOS: "https://apps.apple.com/us/app/ezra-seminary/id6740612880",
    source: "",
  },
  {
    imgsrc: pro2,
    title: "KB Outfit",
    text: "E-commerce application for seamless shopping, built with React Native CLI.",
    android: "https://github.com/yeabtsega45/outfit-ecommerce-mobile-app--react-native/releases/tag/v1.0.0",
    iOS: "",
    source: "https://github.com/yeabtsega45/outfit-ecommerce-mobile-app--react-native",
  },
  {
    imgsrc: pro3,
    title: "Ella Tech",
    text: "A product management mobile app built with Expo and NativeWind.",
    android: "https://expo.dev/artifacts/eas/mT1rwu3SL676bBd1d2aJ5b.apk",
    iOS: "",
    source: "https://github.com/yeabtsega45/ellatech-expo-app--mobile",
  }
];

export default MobileData;
